module.exports = __webpack_public_path__ + "static/img/title.3b959d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/hugelshofer/title.jpg
// module id = 391
// module chunks = 1